import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_496: DocMigration = {
  maxSchemaVersion: "0.0.496",
  description: "Add positioning method to drawing template instances",
  apply(json: any): any {
    const { contentTemplateInstances = {} } = json;
    for (const id of Object.keys(contentTemplateInstances)) {
      const instance = contentTemplateInstances[id];
      if (instance.templateType === "DRAWING") {
        instance.positioningMethod = "GLOBAL";
      }
    }
    json.contentTemplateInstances = contentTemplateInstances;
    return json;
  },
};

export default migration_0_0_496;
